import React from "react";
import styles from "./styles.module.css";

interface CustomTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  error?: string;
  touched?: boolean;
  label?: string;
}

export const CustomTextarea = ({
  name,
  error,
  touched,
  label,
  ...restProps
}: CustomTextareaProps) => (
  <div className={styles.formControl}>
    {label && <p className={styles.label}>{label}</p>}
    <textarea
      id={name}
      name={name}
      className={`${styles.textarea} ${error && touched ? styles.error : ""}`}
      {...restProps}
    />
    {error && touched && <div className={styles.errorText}>{error}</div>}
  </div>
);
